import React from 'react';
import { Icon } from './Icon.js';
export const IconMonitor = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M8 18L7 22H17L16 18", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M22 4L22 18L2 18L2 4L22 4Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconMonitor.js.map